import ErrorBoundary from '@/components/Error/ErrorBoundary/ErrorBoundary';
import { CommonError } from '@/components/Error/CommonError/CommonError';
import { DashboardView } from '@/views/DashboardView/DashboardView';

export const DashboardPage = () => {
  return (
    <>
      <ErrorBoundary fallback={<CommonError variant="reload" />}>
        <DashboardView />
      </ErrorBoundary>
    </>
  );
};
